// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FORUM_WHERE_IS_DISCUSSED = "Kde sa diskutuje";
export const HOME_ADD_PANEL_TEXT = "\u010co m\u00e1\u0161 na srdci?";
export const HOME_ADD_PANEL_TEXT_PERSONAL_username = "%(username)s, \u010do m\u00e1\u0161 na srdci?";
export const HOMEPAGE_ADD_BUTTON = "Pridaj";
export const HOME_RIGHT_LATEST_REVIEWS = "Najnov\u0161ie hodnotenia";
export const HOME_RIGHT_MORE_REVIEWS = "\u010eal\u0161ie hodnotenia...";
